// extracted by mini-css-extract-plugin
export default {"logoutBtn":"LogoutBtn_logoutBtn__f4Lsv"};